<template>
  <div class="bg-soft bg-header-pattern py-6 lg:py-10">
    <div class="max-w-screen-lg mx-auto lg:px-0 px-4 pb-4">
    
      <div class="my-14 text-center">
        <h1
          class="text-2xl lg:text-3xl font-semibold"
          :class="{ 'font-inter': locale == 'vi' }"
        >
          {{ dataLocale.data.title }}
        </h1>
      </div>
      <div class="lg:w-fit mx-auto w-full">
        <TabGroup @change="handleTabChange">
          <TabList
            class="flex items-center h-12 gap-16 px-8 lg:justify-center max-w-full overflow-x-auto overflow-y-hidden pb-2"
          >
            <Tab
              class="h-full relative outline-none whitespace-nowrap"
              v-slot="{ selected }"
            >
              <span
                class="text-base"
                :class="{ 'text-success font-medium': selected }"
                >{{ dataLocale.data.t3 }}</span
              >
              <span
                class="absolute z-10 -bottom-2 h-0.5 xs:h-1 w-full bg-success left-0 rounded-lg"
                v-if="selected"
              ></span>
            </Tab>
            <Tab
              class="h-full relative outline-none whitespace-nowrap"
              v-slot="{ selected }"
            >
              <span
                class="text-base"
                :class="{ 'text-success font-medium': selected }"
                >{{ dataLocale.data.t1 }}</span
              >
              <span
                class="absolute z-10 -bottom-2 h-0.5 xs:h-1 w-full bg-success left-0 rounded-lg"
                v-if="selected"
              ></span>
            </Tab>

            <Tab
              class="h-full relative outline-none whitespace-nowrap"
              v-slot="{ selected }"
            >
              <span
                class="text-base"
                :class="{ 'text-success font-medium': selected }"
                >{{ dataLocale.data.t2 }}</span
              >
              <span
                class="absolute z-10 -bottom-2 h-0.5 xs:h-1 w-full bg-success left-0 rounded-lg"
                v-if="selected"
              ></span>
            </Tab>
          </TabList>
          <div
            class="w-full h-0.5 xs:h-1 bg-gray-200 rounded-md -mt-0.5 xs:-mt-1"
          ></div>
          <TabPanels class="mt-12">
            <TabPanel>
              <ScannerQrCodeCamera ref="camera" :track="track" />
            </TabPanel>
            <TabPanel>
              <ScannerQrCodeCapture />
            </TabPanel>
            <TabPanel>
              <ScannerQrCodeUrl />
            </TabPanel>
          </TabPanels>
        </TabGroup>
      </div>
    </div>
  </div>
  <ClientOnly>
    <ScannerResponseDialog />
    <ScannerComponentApi />
  </ClientOnly>
  <PartialsMarketingCampaign />
  <PartialsTrackQrWidget />
  <PartialsAgencyCarousel />
</template>
<script lang="ts" setup>
import { TabGroup, TabList, Tab, TabPanels, TabPanel } from "@headlessui/vue";
import moment from "moment";
import DataLocale from "~~/config/interface/DataLocale";
import ToolLocale from "~~/config/widgets/tools-widget";
const { locale } = useI18n();
const camera = ref(null);
const dataLocale = new DataLocale([
  {
    locale: "en",
    title: "Optimal QR Code Scanner Online",
    t1: "Upload QR code image",
    t2: "Enter the QR code image URL",
    t3: "The camera scans the QR code",
  },
  {
    locale: "vi",
    title: "Quét mã QR Code Online",
    t1: "Tải lên hình ảnh mã QR",
    t2: "Nhập URL hình ảnh mã QR",
    t3: "Máy ảnh quét mã QR",
  },
  {
    locale: "es",
    title: "Escanear Codigo QR",
    t1: "Cargar imagen de código QR",
    t2: "Ingrese la URL de la imagen de código QR",
    t3: "La cámara escanea el código QR",
  },
  {
    locale: "de",
    title: "QR Code Scanner",
    t1: "QR-Code-Bild hochladen",
    t2: "Geben Sie die URL des QR-Code-Bildes ein",
    t3: "Die Kamera scannt den QR-Code",
  },
  {
    locale: "fr",
    title: "Scanner QR Code",
    t1: "Télécharger l'image du code QR",
    t2: "Entrez l'URL de l'image du code QR",
    t3: "L'appareil photo scanne le code QR",
  },
  {
    locale: "it",
    title: "QR Code Scanner",
    t1: "Carica l'immagine del codice QR",
    t2: "Inserisci l'URL dell'immagine del codice QR",
    t3: "La fotocamera scansiona il codice QR",
  },
  {
    locale: "nl",
    title: "QR Code Scanner",
    t1: "QR-code afbeelding uploaden",
    t2: "Voer de URL van de QR-code afbeelding in",
    t3: "De camera scant de QR-code",
  },
  {
    locale: "ja",
    title: "QR Code Scanner",
    t1: "QRコード画像をアップロードする",
    t2: "QRコード画像のURLを入力してください",
    t3: "カメラがQRコードをスキャンします",
  },
  {
    locale: "pt",
    title: "Leitor Codigo QR Online",
    t1: "Carregar imagem do código QR",
    t2: "Inserir a URL da imagem do código QR",
    t3: "A câmera escaneia o código QR",
  },
  {
    locale: "zh",
    title: "QR码解码器",
    t1: "上传QR码图片",
    t2: "输入QR码图片URL",
    t3: "相机扫描QR码",
  },
]);
const tools = new ToolLocale().data;
const localePath = useLocalePath();
//@ts-ignore
const track = (detectedCodes, ctx) => {
  for (const detectedCode of detectedCodes) {
    const {
      boundingBox: { x, y, width, height },
    } = detectedCode;
    ctx.lineWidth = 2;
    ctx.strokeStyle = "#039ded";
    ctx.strokeRect(x, y, width, height);
  }
};

const handleTabChange = (index: number) => {
  console.log(camera.value);
  if (camera.value) {
    //@ts-ignore
    camera.value.beforeResetCamera();
  }
};

const seoheader = new DataLocale([
  {
    locale: "en",
    title: "QR Code Scanner Online",
    description:
      "The most accurate and fastest online QRGateway QR code decoder can upload QR code photos, scan QR codes with a computer camera to analyze QR code and evaluate by decoding content.",
    keywords:
      " QR code decoding, QR code online decoding, QR decoder, QR code scanner, online reading QR code image content, QR code platform, qr code scanning software, qr code recognition software, two-dimensional code scanning, qr code online analysis",
  },
  {
    locale: "vi",
    title: "Quét mã QR trực tuyến",
    description:
      "Trình giải mã mã QR trực tuyến QRGateway chính xác và nhanh nhất có thể tải lên ảnh mã QR, quét mã QR với camera máy tính để phân tích mã QR và đánh giá bằng cách giải mã nội dung.",
    keywords:
      "Giải mã mã QR, Giải mã trực tuyến mã QR, Trình giải mã QR, Máy quét mã QR, Đọc nội dung hình ảnh mã QR trực tuyến, Nền tảng mã QR, Phần mềm quét mã QR, Phần mềm nhận dạng mã QR, Quét mã hai chiều, Phân tích mã QR trực tuyến",
  },
  {
    locale: "ja",
    title: "オンラインQRコードスキャナー",
    description:
      "最も正確で高速なQRGateway QRコードデコーダーを使用すると、QRコードの写真をアップロードしたり、コンピューターカメラでQRコードをスキャンして解析し、デコードされた内容で評価できます。",
    keywords:
      "QRコードのデコード、オンラインQRコードのデコード、QRデコーダー、QRコードスキャナー、オンラインQRコード画像の読み取り、QRコードプラットフォーム、QRコードスキャニングソフトウェア、QRコード認識ソフトウェア、二次元コードスキャン、オンラインQRコード解析",
  },
  {
    locale: "pt",
    title: "Scanner de Código QR Online",
    description:
      "O decodificador de código QR online mais preciso e rápido da QRGateway pode fazer upload de fotos de código QR, digitalizar códigos QR com uma câmera de computador para analisar o código QR e avaliar decodificando o conteúdo.",
    keywords:
      "Decodificação de código QR, decodificação de código QR online, decodificador de QR, scanner de código QR, leitura online do conteúdo da imagem de código QR, plataforma de código QR, software de digitalização de código QR, software de reconhecimento de código QR, digitalização de código bidimensional, análise online de código QR",
  },
  {
    locale: "de",
    title: "Online QR Code Scanner",
    description:
      "Der genaueste und schnellste Online-QRGateway QR-Code-Decoder kann QR-Code-Fotos hochladen, QR-Codes mit einer Computerkamera scannen, um QR-Code zu analysieren und zu bewerten, indem er den Inhalt entschlüsselt.",
    keywords:
      "QR-Code-Decodierung, QR-Code-Online-Decodierung, QR-Decoder, QR-Code-Scanner, Online-Lesen von QR-Code-Bildinhalten, QR-Code-Plattform, QR-Code-Scanning-Software, QR-Code-Erkennungssoftware, Zweidimensionale Code-Scanning, Online-QR-Code-Analyse",
  },
  {
    locale: "fr",
    title: "Scanner de code QR en ligne",
    description:
      "Le décodeur de code QR en ligne QRGateway le plus précis et le plus rapide peut télécharger des photos de code QR, scanner des codes QR avec une caméra d'ordinateur pour analyser le code QR et évaluer en décodant le contenu.",
    keywords:
      "Décodage de code QR, Décodage en ligne de code QR, Décodage de QR, Scanner de code QR, Lecture en ligne de contenu d'image de code QR, Plateforme de code QR, Logiciel de numérisation de code QR, Logiciel de reconnaissance de code QR, Numérisation de code à deux dimensions, Analyse de code QR en ligne",
  },
  {
    locale: "it",
    title: "Scanner codice QR online",
    description:
      "Il decoder di codici QR online QRGateway più preciso e veloce può caricare foto di codici QR, scansionare codici QR con una fotocamera del computer per analizzare il codice QR e valutare decodificando il contenuto.",
    keywords:
      "Decodifica codice QR, decodifica online di codice QR, decodificatore QR, scanner di codice QR, lettura online del contenuto dell'immagine del codice QR, piattaforma QR Code, software di scansione codice QR, software di riconoscimento codice QR, scansione di codice bidimensionale, analisi online del codice QR",
  },
  {
    locale: "zh",
    title: "在线二维码扫描器 - 在线二维码解码器",
    description:
      "最准确和最快的QRGateway在线二维码解码器可以上传QR码照片，使用电脑摄像头扫描QR码以分析QR码并通过解码内容进行评估。",
    keywords:
      "QR码解码，QR码在线解码，QR解码器，QR码扫描器，在线阅读QR码图像内容，QR码平台，QR码扫描软件，QR码识别软件，二维码扫描，QR码在线分析",
  },
  {
    locale: "es",
    title:
      "Escáner de código QR en línea - Decodificador de código QR en línea",
    description:
      "El decodificador de código QR en línea más preciso y rápido de QRGateway puede cargar fotos de códigos QR, escanear códigos QR con una cámara de computadora para analizar el código QR y evaluar decodificando su contenido.",
    keywords:
      "Decodificación de códigos QR, decodificación de códigos QR en línea, decodificador de códigos QR, escáner de códigos QR, lectura en línea de contenido de imágenes de códigos QR, plataforma de códigos QR, software de escaneo de códigos QR, software de reconocimiento de códigos QR, escaneo de códigos bidimensionales, análisis en línea de códigos QR",
  },
  {
    locale: "nl",
    title: "Online QR Code Scanner - Online QR Code Decoder",
    description:
      "De meest nauwkeurige en snelste online QRGateway QR-code decoder kan QR-codefoto's uploaden, QR-codes scannen met een computercamera om de QR-code te analyseren en evalueren door de inhoud te decoderen.",
    keywords:
      "QR-code decoderen, QR-code online decoderen, QR-decoder, QR-code scanner, online lezen van QR-codebeeldinhoud, QR-codeplatform, QR-code scannen software, QR-code herkenningssoftware, tweedimensionale codescanning, online analyse van QR-code",
  },
]);
const datajd = useDataJd();
const meta = useMeta();
const meta_tags = meta.metaTag({
  title: seoheader.data.title,
  description: seoheader.data.description,
  url: datajd.currentURL(),
  image: datajd.assets("/images/og/generator.jpg"),
});
const i18nHead = useLocaleHead({
  addSeoAttributes: {
    canonicalQueries: ["/"],
  },
});
useHead({
  title: seoheader.data.title,
  meta: [
    { name: "description", content: seoheader.data.description },
    { name: "keywords", content: seoheader.data.keywords },
    ...(i18nHead.value.meta || []),
    ...meta_tags,
  ],
  htmlAttrs: {
    lang: i18nHead.value.htmlAttrs!.lang,
  },
  link: [...(i18nHead.value.link || [])],
});

useSchemaOrg([
  defineWebPage({
    name: seoheader.data.title,
    datePublished: moment("2023-05-03").toISOString(),
    dateModified: moment().toISOString(),
    description: seoheader.data.description,
    inLanguage: datajd.inLanguages(true),
    url: datajd.currentURL(),
    image: datajd.assets("/images/og/generator.jpg"),
  }),
  defineBreadcrumb({
    itemListElement: [
      {
        item: {
          "@id": datajd.currentHost(),
          name: "Home",
        },
      },
      { item: { name: useI18n().t("page.scanner"), "@id": datajd.currentHost()+useRoute().path } },
    ],
  }),
]);
</script>
